export enum StatusIdE {
  Undefined = 'Undefined',
  Draft = 'Draft',
  Open = 'Open',
  Closed = 'Closed',
  ReOpened = 'ReOpened',
}

export enum TicketsViewModeE {
  List = 'List',
  Cards = 'Cards',
}

export enum TicketAssigneeE {
  WarrCloud = 'WarrCloud',
  Chirp = 'Chirp',
}

export enum TicketUserTypesE {
  Undefined = 'Undefined',
  Chirp = 'Chirp',
  WarrCloud = 'WarrCloud',
}

export enum TicketsRefinementKeysE {
  Status = 'Filter.Status',
  TicketAge = 'Filter.TicketAge',
  RONumber = 'Filter.RONumber',
  SearchTerm = 'Filter.SearchTerm',
  AssigneeId = 'Filter.AssigneeId',
  RoofTopId = 'Filter.RoofTopId',
  AssignedToMe = 'Filter.AssignedToMe',
  PastMonth = 'Filter.PastMonth',
  Past30Days = 'Filter.Past30Days',
  IsArchived = 'Filter.IsArchived',
  AgentRoofTopRole = 'AgentRoofTopRole',
  Parameter = 'Sorting.Parameter',
  Order = 'Sorting.Order',
  CurrentPage = 'Paging.CurrentPage',
  CountPerPage = 'Paging.CountPerPage',
  Schedule = 'Filter.ClosedROAgeRange',
  Category = 'Filter.TicketCategoryIds',
  SubCategory = 'Filter.TicketSubCategoryIds',
  RequestSubCategoryIds = 'Filter.RequestSubCategoryIds',
  IsSchedule = 'Filter.IsSchedule',
  DMSScheduleAccounts = 'Filter.DMSScheduleAccountIds',
  Assignee = 'Filter.AssigneeName',
  ScheduleFileId = 'Filter.ScheduleFileId',
  WorkTypes = 'Filter.WorkTypes',
}

export enum StatusFilterValuesE {
  Open = 'Open',
  Closed = 'Closed',
}

export enum AgeFilterValuesE {
  Under24Hours = 'Under24hrs',
  Over24Hours = 'Over24hrs',
}

export enum ParameterSortingValuesE {
  RONumber = 'RONumber',
  LineNumber = 'LineNumber',
  Age = 'Age',
  Status = 'Status',
  Assignee = 'Assignee',
  RequestCategory = 'RequestCategory',
  RequestSubcategory = 'RequestSubcategory',
  Amount = 'Amount',
  IsApprovedByDealer = 'IsApprovedByDealer',
  HasAttachment = 'HasAttachment',
  HasTickets = 'HasTickets',
  ClaimStatus = 'ClaimStatus',
  TicketPriority = 'TicketPriority',
  ClaimAge = 'ClaimAge',
  SubCategory = 'SubCategory',
  ClosedROAge = 'ClosedROAge',
  ClosedRODate = 'RoClosedDate',
  Tech = 'TechNumber',
  Advisor = 'AdvisorNumber',
  Vin = 'Vin',
  DMSScheduleAccountNumber = 'DMSScheduleAccountNumber',
  DMSScheduleAccounts = 'DMSScheduleAccounts',
  LastComment = 'LastMessage',
  AuditTrail = 'DetailUpdatedDateTime',
  WorkType = 'WorkType',
}

export enum CountByRoofTopParameterSortingValuesE {
  AssignedToDealerCount = 'AssignedToDealerCount',
  AssignedToWCCount = 'AssignedToWCCount',
  AssignedToOEMCount = 'AssignedToOEMCount',
  Total = 'Total',
  Amount = 'Amount',
  PrimaryAgentFullName = 'PrimaryAgentFullName',
  RoofTopName = 'RoofTopName',
}

export enum TicketActionTypesE {
  Undefined = 'Undefined',
  StatusChange = 'StatusChange',
  Approve = 'Approve',
  GetApproval = 'GetApproval',
  ChangeAssigneeId = 'ChangeAssigneeId',
}

export enum AgentRoleFilterValuesE {
  Primary = 'Primary',
  BackUp = 'BackUp',
}

export enum ScheduleFilterValuesE {
  Undefined = 'undefined',
  LessThan31Days = '0-30',
  From31To60Days = '31-60',
  From61To90Days = '61-90',
  From91To120Days = '91-120',
  Over120Days = '121+',
}

export enum IsScheduleFilterValuesE {
  True = 'true',
  False = 'false',
}

export enum AssigneeFilterValuesE {
  OEM = 'OEM',
  Dealer = 'Dealer',
  WarrCloud = 'WarrCloud',
}

/** Schedule ticket work type (API workTypeId / workType). */
export enum ScheduleWorkTypeE {
  CurrentWork = 'CurrentWork',
  Backlog = 'Backlog',
}

export const isScheduleWorkType = (value: string | null | undefined): value is ScheduleWorkTypeE =>
  value != null && Object.values(ScheduleWorkTypeE).includes(value as ScheduleWorkTypeE);
